import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { DataError, LoadingIndicator } from "@digital-services/ui";

import CountryDropDown from "@countries/components/CountryDropDown";
import { useGetOrganizationDetails } from "@organization/services/use-organization";

import ApplicationsMultiselect from "./ApplicationsMultiselect";
import OrganizationName from "./OrganizationName";
import OrganizationTypeDropDown from "./OrganizationTypeDropDown";
import { ParentOrganizationName } from "./ParentOrganizationName";

const OrganizationForm: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  const { organization, isLoading, error } = useGetOrganizationDetails();

  if (isLoading) {
    return (
      <div className="flex w-full items-center text-base">
        <LoadingIndicator label={t("load.message")} />
      </div>
    );
  }

  if (error) {
    return (
      <DataError
        title={t("load.error.message")}
        message=""
        className="text-left! text-red-600"
      />
    );
  }

  return (
    <>
      <div className="flex w-[342px] flex-col gap-11 py-5">
        <OrganizationName label={t("name.label")} value={organization?.name} />

        <ApplicationsMultiselect />

        <OrganizationTypeDropDown
          label={t("type.label")}
          disabled={true}
          selectedType={organization?.type}
        />

        <CountryDropDown
          label={t("country.label")}
          disabled={true}
          selectedCountryCode={organization?.countryCode}
        />

        <ParentOrganizationName
          parentOrganizationId={organization?.parentOrganizationId}
        />
      </div>
    </>
  );
};

export default OrganizationForm;
